export default __webpack_public_path__ + "static/media/second-opinion.d4cf6abb.svg";